import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { getTicketTypeData } from '@/constants/options/ticket-type.option';
import type { TicketTypeEnum } from '@/types/enums/ticket-type.enum';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'name',
        headerName: 'Tên loại Ticket',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 250,
        renderCell: (params: any) => <HoverCopyCell value={params.row.name} />,
    },
    {
        field: 'type',
        headerName: 'Loại',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params =>
            getTicketTypeData({
                status: params.value as TicketTypeEnum,
                showChip: false,
            }).label,
    },
    {
        field: 'nameTaskCheckType',
        headerName: 'Tên loại Task',
        editable: false,
        sortable: false,
        minWidth: 250,
        flex: 1,
        renderCell: (params: any) => (
            <HoverCopyCell value={params.row.taskCheckType?.name} />
        ),
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        minWidth: 200,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
    {
        field: 'description',
        headerName: 'Mô tả',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: (params: any) => (
            <HoverCopyCell value={params.row.description} />
        ),
    },
];
